import { BookmarkTypes } from '@medflex/shared-types';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { CustomClientEvents } from '@medflex/shared-constants';
import useBookmarks from './useBookmarks';

const useInboxSearchQuery = () => {
  const { [BookmarkTypes.INBOX_SEARCH_QUERY]: searchQueries, load: loadBookmarks } = useBookmarks();
  const dispatch = useDispatch();

  const refresh = useCallback(() => {
    loadBookmarks({
      type: BookmarkTypes.INBOX_SEARCH_QUERY,
    });
  }, [loadBookmarks]);

  const upsert = useCallback(
    data => {
      const existingQuery = searchQueries?.find(({ id }) => id === data.id);

      if (!existingQuery) {
        refresh();
      }

      if (existingQuery?.attributes?.query !== data.query) {
        dispatch.bookmarks.onUpdated([{ id: data.id, attributes: data }]);
      }
    },
    [searchQueries, dispatch, refresh],
  );

  useEffect(() => {
    refresh();
  }, [refresh]);

  const inboxSearchQuery = useMemo(() => {
    if (searchQueries && searchQueries.length > 0) {
      return searchQueries[0].attributes.query;
    }
    return null;
  }, [searchQueries]);

  useEffect(() => {
    const listener = ({ detail }) => upsert(detail);
    window.addEventListener(CustomClientEvents.INBOX_SEARCH_QUERY_CHANGED, listener);

    return () => {
      window.removeEventListener(CustomClientEvents.INBOX_SEARCH_QUERY_CHANGED, listener);
    };
  }, [loadBookmarks, upsert, refresh]);

  return inboxSearchQuery;
};

export default useInboxSearchQuery;
